/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamBreakdownService
 */
import * as References from './ExamBreakdownService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamBreakdownService#submit
 */
export const SUBMIT_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExamBreakdownService_submit';
export const SUBMIT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_MUTATION_FIELD_NAME,
  args: ['trackId', 'attemptId', 'examPath', 'language', 'academyLanguage'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.submitRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});